import { render, staticRenderFns } from "./ScopeKgNetworkGraph.vue?vue&type=template&id=238c4fa8&scoped=true"
import script from "./ScopeKgNetworkGraph.vue?vue&type=script&lang=js"
export * from "./ScopeKgNetworkGraph.vue?vue&type=script&lang=js"
import style0 from "./ScopeKgNetworkGraph.vue?vue&type=style&index=0&id=238c4fa8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c4fa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238c4fa8')) {
      api.createRecord('238c4fa8', component.options)
    } else {
      api.reload('238c4fa8', component.options)
    }
    module.hot.accept("./ScopeKgNetworkGraph.vue?vue&type=template&id=238c4fa8&scoped=true", function () {
      api.rerender('238c4fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealScope/ScopeKgNetworkGraph.vue"
export default component.exports